// @flow
import * as React from 'react';
import Box from 'sail/Box';
import {useFile} from 'docs/data/integration-builder';
import './RightContainer.scss';

import {getVisibleFiles, getFilename} from 'docs/util';

import Group from 'sail/Group';
import {ButtonLink} from 'sail/Button';
import classNames from 'classnames';
import {DownloadButtonLink} from './DownloadButton';

import './FileHeader.scss';

const formatFileName = (filename: string): string => {
  if (filename.match(/pages/)) {
    // Show the full path for Next.js files for a better UX
    return filename;
  }
  return filename.split('/').slice(-1)[0];
};

export const FileHeader = () => {
  const {components, activeFile, setActiveFile} = useFile();
  const filenames = getVisibleFiles(components).map(getFilename);

  return (
    <Box
      padding={{vertical: 16, horizontal: 24}}
      flex={{
        direction: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box className="FileHeader--filenames" margin={{right: 16}}>
        <Group direction="horizontal" alignItems="center" spacing={16}>
          {filenames.map((filename) => (
            <ButtonLink
              key={filename}
              className={classNames(
                'FileHeader--filename',
                activeFile === filename && 'active',
              )}
              icon="document"
              size="small"
              label={formatFileName(filename)}
              color={activeFile === filename ? 'blue800' : 'gray200'}
              onClick={() => setActiveFile(filename)}
            />
          ))}
        </Group>
      </Box>
      <DownloadButtonLink />
    </Box>
  );
};
